enum DataLayerEnum {
  NAME_REFFER = 'NAME_REFFER',
  NAME_CHECKOUT = 'NAME_CHECKOUT',
}

export { DataLayerEnum };
